import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import './search-detailed-page.scss';
import { selectWordResults, selectPptResults, selectExcelResults, selectTaskResults, selectSearchResultSortedArray, selectLoadingSearch, selectSearchInput, selectProjectResults } from '../../redux/search/search.selector';
import SearchResultDetailed from './search-result-detailed/SearchResultDetailed';
import { PulseLoader } from 'react-spinners';
import PropTypes from 'prop-types';

const SearchDetailedPage = ({ match }) => {
    const [results, setResults] = useState([]);
    const [title, setTitle] = useState('');
    const [showAll, setShowAll] = useState(false);

    const loading = useSelector(selectLoadingSearch);
    const searchInput = useSelector(selectSearchInput);
    const allResults = useSelector(selectSearchResultSortedArray);
    const wordResults = useSelector(selectWordResults);
    const pptResults = useSelector(selectPptResults);
    const excelResults = useSelector(selectExcelResults);
    const projectResults = useSelector(selectProjectResults);
    const taskResults = useSelector(selectTaskResults);

    const renderSearchResults = (showAll) => {
        if (!showAll) {
            return (
                <tbody>
                    <tr className='search-results-detailed-title-row'>
                        <td className='search-results-detailed-title'>
                            <div className='search-results-detailed-title-container'>
                                <div className='search-results-detailed-title-icon' style={{ "left": "0px" }} id={title}></div>
                                <span>{title}</span>
                            </div>
                        </td>
                        <td></td><td></td><td></td><td></td><td></td><td></td>
                        <td>{results.length} results</td>
                    </tr>
                    <SearchResultDetailed results={results} type={match.params.type} />
                </tbody>
            );
        } else {
            return (
                <tbody>
                    {results.map((resultsArray, index) => {
                        return resultsArray.length !== 0 ? (
                            <React.Fragment key={`title-${index}`}>
                                <tr className='search-results-detailed-title-row'>
                                    <td className='search-results-detailed-title'>
                                        <div className='search-results-detailed-title-container'>
                                            <div className='search-results-detailed-title-icon' style={{ "left": "0px" }} id={resultsArray[0].title}></div>
                                            <span>{resultsArray[0].title}</span>
                                        </div>
                                    </td>
                                    <td></td><td></td><td></td><td></td><td></td><td></td><td>{resultsArray.length} results</td>
                                </tr>
                                <SearchResultDetailed results={resultsArray} type={match.params.type} />
                                <tr className="spacer"><td></td></tr>
                            </React.Fragment>
                        ) : null;
                    })}
                </tbody>
            );
        }
    };

    useEffect(() => {
        if (match.params.type.includes('docx')) {
            setResults(wordResults);
            setTitle('Docx');
        } else if (match.params.type.includes('ppt')) {
            setResults(pptResults);
            setTitle('PPT');
        } else if (match.params.type.includes('excel')) {
            setResults(excelResults);
            setTitle('Excel');
        } else if (match.params.type.includes('task')) {
            setResults(taskResults);
            setTitle('Task');
        } else if (match.params.type.includes('project')) {
            setResults(projectResults);
            setTitle('Project');
        } else if (match.params.type === 'all') {
            setShowAll(true);
            setResults(allResults);
        }
    }, [match.params.type, wordResults, pptResults, excelResults, projectResults, taskResults, allResults]);

    return (
        <div className='search-results-container'>
            <div className='search-result-header'>
                <div className='search-result-header-text'>
                    Showing Results for '<span style={{ 'fontWeight': 'bolder' }}>{searchInput}</span>'
                </div>
            </div>
            <div className='search-results-table-container'>
                <table className='search-results-table'>
                    <thead className='search-results-header'>
                        <tr>
                            <th className='search-results-header-name'>NAME</th>
                            <th className='search-results-header-location'>RESULT LOCATION</th>
                            <th className='search-results-header-project'>PROJECT NAME</th>
                            <th className='search-results-header-type'>TYPE</th>
                            <th className='search-results-header-members'>MEMBERS</th>
                            <th className='search-results-header-created'>CREATED</th>
                            <th className='search-results-header-lastmod'>LAST MODIFIED</th>
                            <th className='search-results-header-action'>ACTION</th>
                        </tr>
                    </thead>
                    {loading ? (
                        <tbody>
                            <tr>
                                <td colSpan="8" className="loading-indicator">
                                    <PulseLoader />
                                </td>
                            </tr>
                        </tbody>
                        ) : renderSearchResults(showAll)}
                </table>
            </div>
        </div>
    );
};

SearchDetailedPage.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            type: PropTypes.string.isRequired
        }).isRequired
    }).isRequired,
};

export default withRouter(SearchDetailedPage);
